import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {


  isEngineeringMenuOpen = true;
  isTermMenuOpen=false;


  constructor(private router: Router, private route: ActivatedRoute) { }


  ngOnInit(): void {
  }
  di_tcd_obj = {
    "TR": "Business Term",
    "LR": "Entity",
    "LF": "Data View",
    "DS": "Data Store",
    "PF": "Data File",

  }
  configurationObjectForEntites = {
    TR: {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      code: 'TR',
      value: 'Business Term',
      filters:  {
           "and": [
            { "di_tcd": { "=": 'TR' } },
         ]
         },
      crudconfig:{
        route:'term'
      },
       cards:{
            mainHeading: 'di_tech_nm',
            subHeading: 'di_bus_nm',
            imagePath:'../../assets/TR.png',
            actionAreaLeft: 'status_cd',
            actionAreaMid: 'captured_at'
          
          }

    },
    PF: {
      pf_path: 'dd',
      pf_name: 'di',
      app_cd: 'DD',
      code: 'PF',
      value: 'Physical File',
      filters:  {
           "and": [
            { "di_tcd": { "=": 'PF' } },
         ]
         },
      crudconfig:{
        route:'pf'
      },
       cards:{
            mainHeading: 'di_tech_nm',
            subHeading: 'di_bus_nm',
            imagePath:'../../assets/pf.png',
            actionAreaLeft: 'status_cd',
            actionAreaMid: 'captured_at'
          
          }

    },
    CL: {
      pf_path: 'dd',
      pf_name: 'cl',
      app_cd: 'DD',
      code: 'PF',
      value: 'Classification',
      cards:{
        mainHeading: 'cl_cd',
        subHeading: 'cl_val',
        imagePath:'../../assets/cl.png',
        actionAreaLeft: 'status_cd',
        actionAreaMid: 'captured_at'
      
      }

    }
  }
  activeItem:any
  visitList(configObj: any) {
    console.log(configObj)
    let itemObj:any={
      pf_path: configObj?.['pf_path'],
      pf_name: configObj?.['pf_name'],
      app_cd: configObj?.['app_cd'],
      header: {
        code: configObj?.['code'],
        value: configObj?.['value']
      },
      // cards:{
      //   mainHeading: 'prop_id',
      //   subHeading: 'prop_tcd',
      //   description: 'prop_area',
      //   actionAreaLeft: 'rid',
      //   actionAreaMid: 'captured_at'

      // }
     

    }
    if (configObj?.['filters']) {
      itemObj['filters'] = configObj?.['filters']

    }
    if (configObj?.['crudconfig']) {
      itemObj['crudconfig'] = configObj?.['crudconfig']

    }
    if (configObj?.['cards']) {
      itemObj['cards'] = configObj?.['cards']

    }
    this.activeItem=configObj?.['code']
     itemObj = window.btoa(JSON.stringify(itemObj))
   
    this.router.navigate(['list'], { queryParams: { id: itemObj }, relativeTo: this.route });
  }
  setActiveItem(){
    this.activeItem=null;
  }
  

}
